import { useEffect, useState } from "react";
import * as d3 from "d3";
import Item from './items/item.jsx';

function Items (props) {
    const data = props.data.filter(el => el.test),
        getLabel = props.getLabel,
        colors = props.colors,
        prompt = props.prompt;

    const images = [...new Set([].concat(...data.map(el => el.test.filter(item => item.prompt === prompt).map(item => item.image))))]

    const tab = {
        image: '10em',
        answer: '12em',
        count_number: '1em',
        count_rect: '14.5em',
        count: '16em',
        report: '6em'
    }

    useEffect(() => {
    });

  return (
    <div id="items" className="panel" style={{maxWidth: '95%', paddingBottom: '0.5em'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline'}}>
            <h2 style={{margin: '0.5em'}}>{getLabel(prompt)}</h2>
            {/* <div style={{display: 'flex', gap: '1em', padding: '0 1em 0 1em'}}>
                <p className={index === 0 ? 'link link_inactive' : 'link'} onClick={() => setIndex(index-1)}>Previous</p>
                <p className={index === maxindex ? 'link link_inactive' : 'link'} onClick={() => setIndex(index+1)}>Following</p>
            </div> */}
        </div>
            <div className="table">
                <div className="table_row head_row">
                    <div className="table_head" style={{width: tab.image}}>Image</div>
                    <div className="table_head" style={{width: tab.answer}}>Answer</div>
                    <div className="table_head" style={{width: tab.count}}>Count</div>
                    <div className="table_head" style={{width: tab.report}}>Low quality</div>
                    <div className="table_head" style={{width: tab.report}}>Offensive</div>
                </div>
                {images.map((image,i) => {
                    return (
                        <Item 
                            key={i}
                            index={i+1}
                            image={image}
                            prompt={prompt}
                            data={data}
                            getLabel={getLabel}
                            colors={colors}
                            tab={tab}
                        />
                    )
                })}
            </div>
            
        </div>
  );
}

export default Items;
